import { ReactNode, HTMLAttributes } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> { children: ReactNode; }

export default function Card({ children, className="", ...rest }: Props) {
  return (
    <div className={`bg-white border border-slate-200 rounded-xl p-5 ${className}`} {...rest}>
      {children}
    </div>
  );
}
